import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <div className="shop-container">
        <div className="breadcrumb">
          <Link to="/" className="breadcrumb-link">HOME</Link> / <span className="breadcrumb-current">NEW ARRIVALS</span>
        </div>
        
        <div className="shop-header">
          <h1 className="shop-title">NEW ARRIVALS</h1>
           
        </div>

        <p className="shop-description">
          Explore the latest baplehollow clothing, accessories and useful home pieces. Prices are shown in USD.
        </p>

        <div className="product-grid">
          {productData.map((product) => (
            <div className="product-card" key={product.id}>
              <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                <div className="product-image-wrapper">
                  <img src={product.image} alt={product.name} className="product-image" />
                  <span className="product-badge">NEW</span>
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name.toUpperCase()}</h3>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Shop;
